var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment h-100 d-flex direction-column"},[_c('div',{staticClass:"custom-row"})])
}]

export { render, staticRenderFns }